if (!customElements.get('size-chart')) {
  customElements.define(
    'size-chart',
    class SizeChart extends HTMLElement {
      connectedCallback() {
        this.baseUnit = this.dataset.unit;
        this.querySelectorAll('.size-chart__unit').forEach((button) =>
          button.addEventListener('click', () => this.show(button.dataset.unit))
        );
      }

      show(unit) {
        this.querySelectorAll('.size-chart__unit').forEach((button) =>
          button.setAttribute('aria-pressed', button.dataset.unit === unit)
        );

        this.querySelectorAll('td[data-value]').forEach((cell) => {
          const value = cell.dataset.value;
          // Only convert plain numbers or ranges like "70-72"; leave text such as "One size" alone.
          if (unit === this.baseUnit || !/^[\d.\s–-]+$/.test(value)) {
            cell.textContent = value;
            return;
          }
          const factor = unit === 'in' ? 1 / 2.54 : 2.54;
          cell.textContent = value.replace(/\d+(\.\d+)?/g, (number) =>
            String(Math.round(parseFloat(number) * factor * 10) / 10)
          );
        });
      }
    }
  );
}
